<template>
<div class="right">
    <Header></Header>
    <div class="mainTop">
        <div>
          当前位置：
          <router-link :to="{path:'/index'}" tag="span">首页</router-link>>
          <span @click="medical()">{{$route.query.dbcode == 2 ? '上市信息数据库' : '医药公司数据库'}}</span> >
          <span>{{$route.query.company}}</span>
        </div>
        <div></div>
    </div>
    <!-- <div class="rightCenter">
      <div class="centerTit"></div>
      <div @click="downloadFn(0)" class="centerCon">
        <div class="excel" style="cursor: pointer;">
          <img src="@/assets/img/Excel.png" alt />
          下载数据到Excel
        </div>
      </div>
    </div> -->
    <div class="rightBottom">
      <!-- 第一套 -->
      <div class="tabulation">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <div style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 32px;vertical-align: middle;line-height: 32px;color: #333333;">标的情况及交易详情</div>
        </div>
        
        <table class="mailTable" cellspacing="0">
            <tr>
                <td class="column" width="200" colspan="1" rowspan="3" style="text-align:center;">标的情况</td>
                <td class="column" width="200">公司名称</td>
                <td width="200">{{tableData1[0].hComname}}</td>
                <td class="column" width="200">与披露方关系</td>
                <td width="200">{{tableData1[0].hPlrela}}</td>
            </tr>
            <tr>
                <td class="column">股权比例（%）</td>
                <td>{{tableData1[0].gqbl}}</td>
                <td class="column">标的类型</td>
                <td>{{tableData1[0].objtype}}</td>
            </tr>
            
            <tr>
                <td class="column">详细情况</td>
                <td colspan="3" rowspan="1">{{tableData1[0].objdetails}}</td>
            </tr>
            <tr>
                <td class="column" colspan="1" rowspan="6" style="text-align:center;">交易详情</td>
                <td class="column">交易简介</td>
                <td width="200" colspan="3" rowspan="1">{{tableData1[0].jyjj}}</td>
            </tr>
            <tr>
                <td class="column">交易对披露方影响</td>
                <td width="200" colspan="3" rowspan="1">{{tableData1[0].jydplfyx}}</td>
            </tr>
            <tr>
                <td class="column">支付方式</td>
                <td>{{tableData1[0].methodpay}}</td>
                <td class="column">最新进度</td>
                <td>{{tableData1[0].jd}}</td>
            </tr>
            <tr>
                <td class="column">并购目的</td>
                <td>{{tableData1[0].purpose}}</td>
                <td class="column">并购方式</td>
                <td>{{tableData1[0].zrfs}}</td>
            </tr>
            <tr>
                <td class="column">控制权是否变更</td>
                <td>{{tableData1[0].isacchange}}</td>
                <td class="column">是否关联交易</td>
                <td>{{tableData1[0].sfgl}}</td>
            </tr>
            <tr>
                <td class="column">披露日期</td>
                <td>{{tableData1[0].scggrq}}</td>
                <td class="column">最新公告日</td>
                <td>{{tableData1[0].announdate}}</td>
            </tr>
        </table>
      </div>
      <!-- 第二套 -->
      <div class="tabulation" style="margin-top:41px;">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <!-- <el-select @change="SelectTimeFn2" v-model="searchData2.value" size="small" placeholder="请选择" style="width:165px;float:right;">
            <el-option
              v-for="item in searchData2.select"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select> -->
          <div style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 32px;vertical-align: middle;line-height: 32px;color: #333333;">买方基本资料</div>
        </div>
        <table class="mailTable" cellspacing="0">
            <tbody v-for='item in tableData2'>
                <tr>
                    <td class="column" width="200" colspan="1" rowspan="3" style="text-align:center;">买方情况</td>
                    <td class="column" width="200">名称</td>
                    <td width="200">{{item.sComname}}</td>
                    <td class="column" width="200">证券代码</td>
                    <td width="200">{{item.scode}}</td>
                </tr>
                <tr>
                    <td class="column">性质</td>
                    <td>{{item.buyxz}}</td>
                    <td class="column">与披露方关系</td>
                    <td>{{item.sPlrela}}</td>
                </tr>
                <tr>
                    <td class="column">受让后持股数量（股）</td>
                    <td>{{item.announdate}}</td>
                    <td class="column">受让后持股比例（%）</td>
                    <td>{{item.srrzzcgbl}}</td>
                </tr>
            </tbody>
        </table>
      </div>
      <!-- 第三套 -->
      <div class="tabulation" style="margin-top:41px;">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <!-- <el-select @change="SelectTimeFn3" v-model="searchData3.value" size="small" placeholder="请选择" style="width:165px;float:right;">
            <el-option
              v-for="item in searchData3.select"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select> -->
          <div style="display: inline-block;float:left;font-size:14px;font-weight:400;height: 32px;vertical-align: middle;line-height: 32px;color: #333333;">卖方基本资料</div>
        </div>
        
        <table class="mailTable" cellspacing="0">
            <tbody v-for='item in tableData3'>
                <tr>
                    <td class="column" width="200" colspan="1" rowspan="5" style="text-align:center;">卖方情况</td>
                    <td class="column" width="200">名称</td>
                    <td width="200">{{item.sComname}}</td>
                    <td class="column" width="200">证券代码</td>
                    <td width="200">{{item.granterhqcode}}</td>
                </tr>
                <tr>
                    <td class="column">性质</td>
                    <td>{{item.buyxz}}</td>
                    <td class="column">与披露方关系</td>
                    <td>{{item.sPlrela}}</td>
                </tr>
                <tr>
                    <td class="column">交易金额（元）</td>
                    <td>{{item.jyje}}</td>
                    <td class="column">币种</td>
                    <td>{{item.bzname}}</td>
                </tr>
                <tr>
                    <td class="column">股权转让比例（%）</td>
                    <td>{{item.zrbl}}</td>
                    <td class="column">转让后持股数量（股）</td>
                    <td>{{item.gbGomnamenum}}</td>
                </tr>
                <tr>
                    <td class="column">转让前持股比例（%）</td>
                    <td>{{item.gfGomnamepor}}</td>
                    <td class="column">转让后持股比例（%）</td>
                    <td>{{item.gbGomnamepor}}</td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
    <Footer></Footer>
</div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
import Header from "@/components/header2";
import Footer from "@/components/footer2";
import $ from 'jquery';
export default {
  data() {
    return {
      tableData1:[],
      tableData2:[],
      tableData3:[],
      //选择数据
      searchData1:{
        select:[],//下拉框选项数据
        value: '',
      },
      searchData2:{
        select:[],//下拉框选项数据
        value: '',
      },
      searchData3:{
        select:[],//下拉框选项数据
        value: '',
      },
      companyList:[],
      paramsData:{}//URL参数集合
    };
  },
  components:{
    rightTop,
    Header,
    Footer
  },
  methods: {
    cellStyle(row,column,rowIndex,columnIndex){
      return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;'
    },
    medical() {
        if(this.$route.query.dbcode == 2){
            this.$router.push({
                path: "/search",
                query: {
                    companyName: "",
                    dbcode: 2,
                    pageNo: 1,
                    pageSize: 10
                }
            });
        }
        if(this.$route.query.dbcode == 1){
            this.$router.push({
                path: "/search",
                query: {
                    companyName: "",
                    dbcode: 1,
                    pageNo: 1,
                    pageSize: 10
                }
            });
        }
    },
    //下载函数
    downloadFn(incomeType){
      let _this = this;
      this.download(window.baseUrl + '/companyBasic/downExecutivesData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode + '&sessionDNum=' + this.searchData2.value.substring(1,2) + '&sessionJNum=' + this.searchData3.value.substring(1,2));
    },
    download(url) {
      let a = document.createElement('a');
      a.href = url;
      let _id = Math.random()+Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    //第一个下拉框
    SelectTimeFn1(val){
      console.log(val,'val');
      this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,'1',val.substring(1,2));//按产品
    },
    SelectTimeFn2(val){
      console.log(val,'val');
      this.fetchTable2(this.paramsData.stockCode,this.paramsData.enterpriseCode,'2',val.substring(1,2));//按行业
    },
    SelectTimeFn3(val){
      console.log(val,'val');
      this.fetchTable3(this.paramsData.stockCode,this.paramsData.enterpriseCode,'3',val.substring(1,2));//按地域
    },
    action(){
      // incomeType=收入类型分类 0:按产品 1:按行业 2:按地域
    //   this.fetchTimes();//获取所有时间的选项
      setTimeout(()=>{
        this.fetchTable1(this.paramsData.bgczCode);//按产品
        // this.fetchTable2(this.paramsData.stockCode,this.paramsData.enterpriseCode,'2',this.searchData2.value.substring(1,2));//按行业
        // this.fetchTable3(this.paramsData.stockCode,this.paramsData.enterpriseCode,'3',this.searchData3.value.substring(1,2));//按地域
        // $('.el-table thead tr th').css({'background':'#F7F7F7','color':'#333','font-size':'14px','font-weight':'400'});
      },500)
    },
    //获取所有时间的选项
    fetchTimes(){
      let _this = this;
      api.baseInfoTableTwoTime(this.paramsData.stockCode,this.paramsData.enterpriseCode,'2').then(res=>{
        let data = res.data;
        let tmpArr = [];
        if(data.length == 0){
          return;
        }
        for(let i=0;i<data.length;i++){
          tmpArr.push('第'+data[i]+'届');
        }
        _this.searchData2.select = tmpArr;
        _this.searchData2.value = tmpArr[0];
      })  
      api.baseInfoTableTwoTime(this.paramsData.stockCode,this.paramsData.enterpriseCode,'3').then(res=>{
        let data = res.data;
        let tmpArr = [];
        if(data.length == 0){
          return;
        }
        for(let i=0;i<data.length;i++){
          tmpArr.push('第'+data[i]+'届');
        }
        _this.searchData3.select = tmpArr;
        _this.searchData3.value = tmpArr[0];
      })  
    },
    fetchTable1(bgczCode){
      let _this = this;
      api.reorganizationDetailOne(bgczCode).then(res=>{
          let data = res.data;
          console.log(data,'data1');
          _this.tableData1 = data.bdqkList;
          _this.tableData2 = data.buyList;
          _this.tableData3 = data.saleList;
          console.log(_this.tableData2,'_this.tableData2')
      })   
    },
    fetchTable2(stockCode,enterpriseCode,executivesType,sessionNum){
      let _this = this;
      api.baseInfoTableTwo(stockCode,enterpriseCode,executivesType,sessionNum).then(res=>{
          let data = res.data;
          console.log(data,'data2');
          _this.tableData2 = data;
      })   
    },
    fetchTable3(stockCode,enterpriseCode,executivesType,sessionNum){
      let _this = this;
      api.baseInfoTableTwo(stockCode,enterpriseCode,executivesType,sessionNum).then(res=>{
          let data = res.data;
          console.log(data,'data3');
          _this.tableData3 = data;
      })   
    }
  },
  mounted() {
    this.paramsData.bgczCode = this.$route.query.bgczCode;
    if(this.paramsData.bgczCode){
        this.action();//获取表格数据
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
.right {
  flex: 1;
  height: auto;
//   margin-right: 23px;
  display: flex;
  flex-direction: column;
  background: #f4f4f4;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    // margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
.mailTable, .mailTable tr, .mailTable tr td{ border:1px solid #08396A; }
.mailTable{ font-size: 14px; color: #4B4B4B; width:100%;font-family:Microsoft YaHei;}
.mailTable tr td{ border:1px solid #08396A; width: 80%; height: 35px; line-height: 35px; box-sizing: border-box; padding: 0 10px; color: #dfecf7; }
.mailTable tr td.column { background-color: #375572;  color: #dfecf7; font-size:14px;font-weight:bold;width:20%;}
.el-table thead{
  background-color: #F7F7F7!important; 
  color: #333333!important;
  font-size:14px!important;
  font-weight:bold!important;
}
.mainTop {
    width: 100%;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5e6064;
    padding-left: 20px;
    span {
      cursor: pointer;
    }
    span:hover {
      color: #3583ed;
    }
}

</style>


// WEBPACK FOOTER //
// src/view/majorevents/reorganizationdetail.vue